import fetchJson from '@atlassian/jira-fetch/src/utils/as-json.tsx';
import type { ManagedCustomFieldsResponse } from './types.tsx';

export const getClassicProjectEpicNameFieldKey = (): Promise<string | undefined> =>
	fetchJson('/rest/greenhopper/1.0/api/managed/customfields').then(
		(fieldsResponse: ManagedCustomFieldsResponse) => fieldsResponse?.epicNameField?.id,
	);
